<template>
    <div id="new-linkedin-channel-form">
        <a-form>
            <div class="form-wrapper">
                <div class="input-wrapper">
                    <label>{{ $t("whatsappChannel.channelName") }}</label>
                    <a-form-item
                        :validate-status="getErrorStatus('channelName')"
                        :help="getErrorMessage('channelName')"
                    >
                        <a-input
                            v-model="form.channelName"
                            :placeholder="$t('whatsappChannel.channelName')"
                            name="channelName"
                            ref="channelName"
                        />
                    </a-form-item>
                </div>

                <div class="input-wrapper">
                    <div class="mt-1 mb-1">
                        <a-switch :checked="!!form.forward.story" @click="toggleChatbot" />
                        <span>👉 {{ $t("whatsapp_business_api.forwardToChatbot") }}</span>
                    </div>

                    <label>{{ $t("whatsapp_business_api.forwarding") }}</label>
                    <a-select
                        v-model="form.forward.story"
                        @change="handleStoryChange"
                        :defaultValue="null"
                        :notFoundContent="$t('whatsapp_business_api.forwardLiveAgents')"
                        :disabled="!showStories"
                    >
                        <a-select-option :selected="true" :value="null">
                            {{ $t("whatsapp_business_api.forwardLiveAgents") }}
                        </a-select-option>
                        <a-select-option :key="story._id" v-for="story in stories" :value="story._id">
                            {{ story.title }}
                        </a-select-option>
                    </a-select>
                    <br />
                    <label>{{ $t("whatsapp_business_api.forwardingToDepartment") }}</label>
                    <a-select v-model="form.allDepartments" @change="getSubjectTitle" :defaultValue="null">
                        <a-select-option :selected="true" :value="null"
                            >👉{{ $t("whatsapp_business_api.selectDepartment") }}...
                        </a-select-option>
                        <a-select-option :key="department._id" v-for="department of subjects" :value="department._id">
                            {{ getSubjectTitle(department) }}
                        </a-select-option>
                    </a-select>
                </div>
                <VisibilityChanger v-model="form.visibility" />
            </div>
        </a-form>

        <div class="form-footer">
            <div class="actions">
                <a-button @click="handleCancel">{{ $t("message.cancel") }}</a-button>
                <a-button class="pr-confirm-btn" @click="handleSave" type="primary" :disabled="loading">
                    {{ $t("message.save") }}
                </a-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import VisibilityChanger from "../../WhatsappV1/VisibilityChanger.vue";
import { socketMessageStream } from "../../../../utils/socketStream";
import { filter } from "rxjs/operators";

export default {
    name: "NewLinkedinChannel",
    props: {
        channel: {
            type: Object,
            default: () => {},
        },
    },
    components: {
        VisibilityChanger,
    },
    data() {
        return {
            showStories: false,
            alldepartments: [],
            form: {
                channelName: "",
                forward: {
                    department: null,
                    story: null,
                    mode: "live",
                    hybrid: {
                        department: null,
                    },
                },
            },
            loading: false,
            clone: _.cloneDeep(this.channel),
            submitClicked: false,
        };
    },
    computed: {
        ...mapState({
            stories: (state) => state.CB.stories,
            subjects: (state) => _.get(state.subject.subjects, "data", []) || [],
            debugMode: (state) => state.app.debugMode,
        }),
    },
    methods: {
        ...mapActions({
            createChannel: "channel/createChannel",
        }),

        getErrorStatus(fieldName) {
            return this.form[fieldName].length < 1 && this.submitClicked ? "error" : "";
        },
        getErrorMessage(fieldName) {
            return this.form[fieldName].length < 1 && this.submitClicked ? this.$t("message.requiredChannel") : "";
        },
        toggleChatbot() {
            if (this.showStories) {
                this.form.forward.story = null;
                this.form.forward.mode = "live";
            } else {
                if (this.stories[0]) {
                    this.form.forward.story = this.stories[0]._id;
                    this.form.forward.mode = "chatbot";
                }
            }
            this.showStories = !this.showStories;
        },
        handleStoryChange() {},
        getSubjectTitle(department) {
            const validLangs = Object.keys(department.languageContent);
            const targetLang = validLangs.includes(this.$i18n.locale) ? this.$i18n.locale : validLangs[0];
            const key = `languageContent.${targetLang}.name`;
            return _.get(department, key);
        },
        handleCancel() {
            this.$emit("cancel");
        },
        handleSave() {
            this.submitClicked = true;
            if (this.form.channelName.length < 1) {
                this.$refs.channelName.focus();
                return;
            } else {
                const isValid = true;
                if (isValid) {
                    const payload = {
                        type: "linkedin-unipile",
                        name: this.form.channelName,
                        payload: {},
                        forward: this.form.forward,
                    };
                    this.loading = true;
                    this.createChannel(payload)
                        .then((channel) => {
                            this.$message.success(this.$t("message.channelCreatedSuccessfully"));
                            this.$emit("ok");
                            this.$router.push(`/integrations/linkedin/${channel._id}/detail`);
                        })
                        .catch((err) => {
                            this.$message.error("Failed to create channel");
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
            }
        },
    },
    mounted() {
        this.listenSocket();
    },
    beforeDestroy() {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    },
};
</script>

<style lang="scss" scoped>
#new-linkedin-channel-form {
    min-height: 250px;
    flex-direction: column;

    .form-wrapper {
        padding: 20px;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .input-wrapper {
            display: flex;
            flex-direction: column;
            gap: 5px;
        }
    }

    .form-footer {
        display: flex;
        justify-content: flex-end;
        padding: 10px;
        margin-top: 20px;
        background: var(--color-bg-default);
        border-top: 1px solid var(--color-border-default);
    }
}
</style>

<style lang="scss">
.new-waba {
    .custom-modal-body {
        padding: 0px !important;
    }
}
</style>
